// CYBOGLABS Mock Data

import testriveImage from '../assets/testrive-project.svg';
import wondsImage from '../assets/wonds-project.svg';
import pixzeeImage from '../assets/pixzee-project.svg';
import pixzeepodImage from '../assets/pixzeepod-project.svg';
import spotaxisImage from '../assets/spotaxis-project.svg';
import seabotImage from '../assets/seabot-project.svg';
import matrivisImage from '../assets/matrivis-project.svg';
import lockfeeImage from '../assets/lockfee-project.svg';
import zeptrackImage from '../assets/zeptrack-project.svg';
import spotytagsImage from '../assets/spotytags-project.svg';

export const companyInfo = {
  name: "CYBOGLABS",
  tagline: "Technology & Life",
  email: "support@cyboglabs.com",
  careersEmail: "careers@cyboglabs.com",
  vision: "To emerge as the world's leader in R&D, creating long-term innovation that defines the future of technology and enhances human affairs around the globe.",
  mission: "To deliver high-impact R&D solutions that address real-world challenges. To foster innovation through collaboration, creativity & technology. To empower businesses with scalable, efficient & future-ready solutions.",
  about: "We are a future-driven R&D powerhouse committed to pushing boundaries and turning visionary ideas into cutting-edge innovations. For us, the future isn't something to predict, it's something to create."
};

export const faqData = [
  {
    id: 1,
    category: "General",
    question: "What is CYBOGLABS?",
    answer: "CYBOGLABS is a future-driven R&D powerhouse committed to pushing boundaries and turning visionary ideas into cutting-edge innovations. Our tagline 'Technology & Life' reflects our mission to create technology that enhances human affairs around the globe."
  },
  {
    id: 2,
    category: "General",
    question: "What are CYBOGLABS' core specialties?",
    answer: "We specialize in six key areas: Product-Driven Engineering R&D, AI & Machine Learning Systems, Hardware-Software Co-Development, Technology Problem Solving, Experimental Prototyping & Validation, and End-to-End Product Ownership."
  },
  {
    id: 3,
    category: "Products",
    question: "What products has CYBOGLABS developed?",
    answer: "We have developed multiple innovative products including SpotyTags (hospitality automation), Pixzee.ai (AI fashion platform), PixzeePod (retail assistant), Seabot.ai (marine data platform), Matrivis (warehouse intelligence), TestRive (driving simulation), Lockfee & SpotAxis (parking solutions), ZepTrack (pharmacy automation), and WONDS (warranty platform)."
  },
  {
    id: 4,
    category: "Products",
    question: "What is Matrivis and why was it selected by IIT Madras?",
    answer: "Matrivis is a digital warehouse intelligence system designed for port and logistics operations. It was selected by IIT Madras for the Port Innovation Challenge 2025 to transform Chennai port operations due to its innovative approach to real-time cargo tracking, AI-powered predictive analytics, and seamless integration capabilities."
  },
  {
    id: 5,
    category: "Careers",
    question: "What career opportunities are available at CYBOGLABS?",
    answer: "We are currently hiring for DevOps Engineer (3-6 years), AI/ML Architect (5-10 years), Cloud Architect (6-10 years), and Hardware & Embedded Systems Engineer (4-8 years). Visit our Careers page or email careers@cyboglabs.com for more details."
  },
  {
    id: 6,
    category: "Careers",
    question: "Does CYBOGLABS offer internships?",
    answer: "Yes! We offer paid internships in AI/ML Research, Full Stack Development, Embedded Systems, and Cloud & DevOps. Internships typically last 3-6 months and provide hands-on experience with real projects, mentorship from industry experts, and potential pre-placement opportunities."
  },
  {
    id: 7,
    category: "Careers",
    question: "What is the work culture at CYBOGLABS?",
    answer: "CYBOGLABS fosters an innovation-first culture with collaborative teams, flexible work arrangements (hybrid/remote options), continuous learning opportunities, and a focus on work-life balance. We believe in empowering our team members to experiment, learn, and grow."
  },
  {
    id: 8,
    category: "Services",
    question: "Does CYBOGLABS provide R&D services to other companies?",
    answer: "Yes, we offer comprehensive R&D services including applied research, experimental development, reverse engineering, technology problem solving, prototyping, and end-to-end product development. Contact us at support@cyboglabs.com to discuss your requirements."
  },
  {
    id: 9,
    category: "Services",
    question: "What industries does CYBOGLABS serve?",
    answer: "We serve multiple industries including hospitality, retail & fashion, maritime & logistics, healthcare & pharmacy, automotive, parking & smart cities, and consumer electronics. Our solutions are designed to solve real-world challenges across these sectors."
  },
  {
    id: 10,
    category: "Contact",
    question: "How can I contact CYBOGLABS?",
    answer: "You can reach us through multiple channels: General inquiries at support@cyboglabs.com, Career-related queries at careers@cyboglabs.com, or use our contact form on the website. You can also chat with CYBOT, our AI assistant, for quick answers."
  },
  {
    id: 11,
    category: "Contact",
    question: "Where is CYBOGLABS located?",
    answer: "CYBOGLABS operates with a hybrid work model. For specific location details or to schedule a meeting, please contact us at support@cyboglabs.com."
  },
  {
    id: 12,
    category: "Technology",
    question: "What technologies does CYBOGLABS work with?",
    answer: "We work with cutting-edge technologies including AI/ML frameworks (PyTorch, TensorFlow), cloud platforms (AWS, GCP, Azure), embedded systems (ARM, ESP32, STM32), containerization (Docker, Kubernetes), and various programming languages (Python, C/C++, JavaScript)."
  }
];

export const specialties = [
  {
    id: 1,
    title: "Product-Driven Engineering R&D",
    description: "We conduct applied research and experimental development to create original, IP-led technology products.",
    icon: "FlaskConical"
  },
  {
    id: 2,
    title: "AI & Machine Learning Systems",
    description: "We design and implement AI and ML models as core components of our products, focusing on real-world applicability, automation, and intelligent decision-making.",
    icon: "Brain"
  },
  {
    id: 3,
    title: "Hardware–Software Co-Development",
    description: "We build integrated systems where custom hardware, embedded firmware, and software platforms are developed together to solve complex operational challenges.",
    icon: "Cpu"
  },
  {
    id: 4,
    title: "Technology Problem Solving",
    description: "We take on difficult, unsolved engineering challenges and translate them into scalable, practical technology solutions through structured experimentation and iteration.",
    icon: "Lightbulb"
  },
  {
    id: 5,
    title: "Experimental Prototyping & Validation",
    description: "We rapidly prototype, test, and refine concepts to validate feasibility, performance, and market relevance before moving toward productization.",
    icon: "Cog"
  },
  {
    id: 6,
    title: "End-to-End Product Ownership",
    description: "From concept and research to design, development, and IP creation, all core innovation is conceived and built in-house, with manufacturing executed through trusted partners.",
    icon: "Rocket"
  }
];

export const projects = [
  {
    id: 1,
    name: "SpotyTags",
    tagline: "Hospitality Automation Platform",
    description: "Hospitality-focused automation platform for intelligent tracking and billing of in-room consumables.",
    status: "Active",
    image: spotytagsImage
  },
  {
    id: 2,
    name: "Pixzee.ai",
    tagline: "AI-Driven Apparel Platform",
    description: "An AI-driven apparel platform that blends personalization, automation, and digital intelligence into fashion retail.",
    status: "Active",
    image: pixzeeImage
  },
  {
    id: 3,
    name: "PixzeePod",
    tagline: "AI-Powered Retail Assistant",
    description: "An AI-powered retail assistant designed to enhance customer interaction and in-store decision support.",
    status: "Active",
    image: pixzeepodImage
  },
  {
    id: 4,
    name: "Seabot.ai",
    tagline: "Intelligent Marine Data Platform",
    description: "An intelligent marine data platform built to enable real-time monitoring and insights in maritime environments.",
    status: "Active",
    image: seabotImage
  },
  {
    id: 5,
    name: "Matrivis",
    tagline: "Digital Warehouse Intelligence",
    description: "A digital warehouse intelligence system designed for port and logistics operations to improve visibility and control.",
    status: "Active",
    image: matrivisImage
  },
  {
    id: 6,
    name: "TestRive",
    tagline: "Virtual Driving Simulation",
    description: "A virtual driving and simulation platform created to evaluate, train, and validate vehicle interaction scenarios.",
    status: "Active",
    image: testriveImage
  },
  {
    id: 7,
    name: "Lockfee",
    tagline: "Automated Parking Compliance",
    description: "An automated parking compliance solution that enables digital payment and controlled clamp release with minimal manual intervention.",
    status: "Active",
    image:  lockfeeImage
  },
  {
    id: 8,
    name: "SpotAxis",
    tagline: "Smart Parking Assistance",
    description: "A smart parking assistance platform focused on improving flow, compliance, and operational efficiency in managed parking environments.",
    status: "Active",
    image: spotaxisImage
  },
  {
    id: 9,
    name: "ZepTrack",
    tagline: "Pharmacy Automation Platform",
    description: "An automation platform designed to streamline pharmacy operations and inventory-driven workflows.",
    status: "Active",
    image:  zeptrackImage
  },
  {
    id: 10,
    name: "WONDS",
    tagline: "Digital Warranty Platform",
    description: "A digital warranty and after-sales platform that simplifies product ownership and service access for end users.",
    status: "Active",
    image: wondsImage
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Safety by Design: Lessons from the Ahmedabad Aviation Tragedy",
    excerpt: "On June 12, 2025, tragedy struck when Air India Flight AI 171, en route from Ahmedabad to London, crashed shortly after takeoff.",
    content: `On June 12, 2025, tragedy struck when Air India Flight AI 171, en route from Ahmedabad to London, crashed shortly after takeoff. The Boeing 787 Dreamliner suffered a catastrophic failure, making headlines as the first fatal crash involving a 787 aircraft.\n\nAs investigations unfold and the nation mourns, we're left with one pressing, universal question: Could this have been prevented?\n\nAt Cyboglabs, this incident reinforces a belief we hold at the core of every project: Safety is not an afterthought. It must be designed from Day One.\n\nBeyond identifying a cause, this moment calls for a deeper conversation: Are we designing our technologies, across industries, to survive failure?\n\n**What Is "Safety by Design"?**\n\n"Safety by Design" is more than just engineering; it's a mindset. It means:\n\n• Anticipating failure, not assuming everything will work perfectly\n• Designing redundancies, so if one system fails, another takes over\n• Building intuitive, fault-tolerant interfaces for human operators\n• Testing under stress, not just under ideal lab conditions\n\nIn critical systems—aviation, healthcare, transport, industrial control—this approach saves lives.\n\n**Lessons for Tech Innovators**\n\nWhile this was an aviation tragedy, the lessons echo far beyond airports and runways. As builders of technology, we must ask:\n\n• Have we tested this system to fail safely?\n• Are our users empowered to act when something goes wrong?\n• Is our product designed with real-world unpredictability in mind?\n\nAt Cyboglabs, our R&D process is grounded in redundancy, reverse engineering, and fail-safe testing. Whether we're developing hardware systems, software modules, or automation workflows, our goal is resilience, not just functionality.`,
    date: "June 2025",
    category: "Safety",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&auto=format&fit=crop&q=60",
    author: "Cyboglabs Team"
  },
  {
    id: 2,
    title: "Fail-Fast Culture: Accelerating Innovation Through Rapid Learning",
    excerpt: "In a world moving at breakneck speed, success isn't about getting it perfect the first time. It's about learning faster than anyone else.",
    content: `In a world moving at breakneck speed, success isn't about getting it perfect the first time. It's about learning faster than anyone else. That's where the fail-fast culture comes in.\n\nIt's not about celebrating failure — it's about failing with purpose. You test an idea → it doesn't work → you learn → you move forward smarter. That's innovation on fast-forward.\n\n**Why It Works in Tech (and Beyond)**\n\n1. Speed over Perfection: You don't wait months for a perfect product. You launch early, learn quickly, and evolve.\n\n2. Resource Smart: Time, money, and energy are saved by scrapping what doesn't work-fast.\n\n3. Data-Driven Decisions: Real feedback beats assumptions. Fail-fast thrives on facts, not guesses.\n\n4. Creative Confidence: Teams feel safe to experiment when failure isn't feared — it's fuel.\n\n**Real-Life Example**\n\nConsider startups developing Minimum Viable Products (MVPs). They test, tweak, pivot — all before scaling. Companies like Netflix and Airbnb didn't nail it on day one. But they iterated fast — and that made all the difference.\n\n**Shifting the Mindset**\n\nTo embrace this culture, businesses must:\n\n• Stop punishing failure\n• Reward learning speed\n• Encourage open feedback\n• Build agile teams ready to pivot\n\nIt's not just a method — it's a mindset.\n\n**Final Thought: The Future Favours the Fast**\n\nIn innovation, it's not the strongest who win. It's the most adaptable, the most curious, and the ones who are willing to fall fast and rise faster.`,
    date: "May 2025",
    category: "Innovation",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop&q=60",
    author: "Cyboglabs Team"
  },
  {
    id: 3,
    title: "The Future of Work: Humans + AI Not Humans vs AI",
    excerpt: "Artificial intelligence has seeped into our lives, from smart assistants to automated workflows. Is AI replacing us, or is it here to assist us?",
    content: `Artificial intelligence has seeped into our lives, from smart assistants to automated workflows. Now, a powerful question arises: Is AI replacing us, or is it here to assist us?\n\nThere's a lot of fear right now about AI. Will it take over jobs? Are machines taking over creativity or decision-making? But here's the truth: We are entering a new era in which the most successful corporations and individuals will be those who welcome AI as a powerful collaborator.\n\nAI is not coming to take humans' jobs. It's here to augment us.\n\n**What AI Does Best**\n\n• Repetitive tasks\n• Sorting & searching large sets of data\n• Recognizing patterns and predicting outcomes\n• Automating routine processes\n• Continuously running 24/7 without fatigue\n\n**What Humans Do Best**\n\nHumans bring what AI can't replicate: Emotion. Intuition. Creativity. Compassion. The real magic comes from blending AI logic and human intuition.\n\nSo, let's create systems that hand over the heavy lifting to AI, freeing up humans for more meaningful work.\n\n**At Cyboglabs, we don't see AI as a threat.**\n\nIt is an opportunity to grow, to develop, and to do better. The future of work isn't about choosing sides. It's about joining forces. This is a world in which humans and AI are engaged in creative collaboration rather than combative competition!`,
    date: "April 2025",
    category: "AI",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&auto=format&fit=crop&q=60",
    author: "Cyboglabs Team"
  },
  {
    id: 4,
    title: "Emerging Industry Trends Shaping Innovation",
    excerpt: "Gain knowledge of the most recent developments in the industry to stay ahead of the curve in research and development.",
    content: `Gain knowledge of the most recent developments in the industry to stay ahead of the curve in research and development. Learn how sustainable technology, AI, and IoT are transforming innovation for engineers and businesses alike.\n\n**Key Trends that would shape the Future of R&D**\n\n• **Artificial Intelligence & Machine Learning in R&D** - AI and ML change how R&D teams analyze data, improve processes and accelerate innovation.\n\n• **The Rise of Quantum Computing** - Quantum computing will revolutionize R&D by solving complex problems that traditional computers cannot even approach.\n\n• **Sustainable and Green Technologies** - Sustainability is no longer a trend — it's a necessity. Green R&D is yielding energy-efficient technologies.\n\n• **Internet of Things (IoT) in Research** - IoT in R&D is producing connected, intelligent solutions with real-time data collection.\n\n• **Reverse Engineering & Digital Resurrection** - Reverse engineering is essential to rescuing legacy systems and fixing legacy technology.\n\n**How Businesses Can Take Advantage of These Trends**\n\nUnderstanding these trends is not enough — acting on them is the challenge. Businesses that want to survive in this new landscape will have to bring the cutting edge in-house and invest in R&D by modernizing their infrastructure, systems, and cultures of innovation.`,
    date: "March 2025",
    category: "Trends",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&auto=format&fit=crop&q=60",
    author: "Cyboglabs Team"
  },
  {
    id: 5,
    title: "Reviving Obsolete Technologies Through Reverse Engineering",
    excerpt: "Tens of thousands of innovations are broken or abandoned in the fast-paced world of technological change.",
    content: `Tens of thousands of innovations are broken or abandoned in the fast-paced world of technological change. But reverse engineering is reviving these lost technologies, showing that the future lies in the past.\n\n**Why Reverse Engineering Matters for Obsolete Technologies**\n\nWhile industries struggle with outdated systems, reverse engineering is the answer to:\n\n• **Legacy System Modernization** - Upgrading old infrastructure to work with newer technologies\n• **Software Restoration & Migration** - Breathing new life into obsolete software\n• **Cyber Security & Vulnerability Assessment** - Exploit security holes before they become a liability\n• **Hardware Replication & Innovation** - Rebuilding obsolete components for aerospace, defence and industrial use\n\n**Digital Resurrection: Use Cases**\n\n• Vintage Software & Operating Systems Restoration\n• Manually Rebuilding Non-Existent Hardware Components\n• Retrofitting Legacy Systems for IoT & AI\n• Cybersecurity Analysis & Threat Mitigation\n\n**The Art of Reverse Engineering in the Age of AI**\n\nAI-based reverse engineering is aiding to speed up the digital resurrection process through:\n\n• Automating Code Analysis\n• Predictive Restoration\n• Data-Driven Component Replication`,
    date: "February 2025",
    category: "Engineering",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&auto=format&fit=crop&q=60",
    author: "Cyboglabs Team"
  },
  {
    id: 6,
    title: "The Story Behind Wonds",
    excerpt: "We've all been there, getting a shiny new gadget and looking forward to utilizing its features, only to have it malfunction on us.",
    content: `We've all been there, getting a shiny new gadget and looking forward to utilizing its features, only to have it malfunction on us. That's when the real headache starts — hunting for the receipt, determining if the warranty is still valid, calling customer service and often, facing lengthy delays.\n\nWe were sure there had to be a better alternative. Wonds was born from our own frustration with lost receipts, missed warranty deadlines, and complicated claims. We wanted to build something very simple, a service that helps you be worry-free about warranties again.\n\n**What is Wonds?**\n\nYour one-stop solution for warranty tracking and hassle-free servicing. If you purchase a product, you can subscribe to Wonds for a small fee. From that point forward, we do it all.\n\n**Features:**\n\n• **Auto Warranty Tracking** - No more scrambling to find receipts; we track all of your warranties in one place.\n• **Warranty Updates on Time** - We remind you before your warranty expires so that you can take action.\n• **Claim with No Fuss** - Need a repair? We provide doorstep pickup and delivery, so you can stay hassle-free!\n\n**Why Wonds?**\n\n• No More Lost Receipts\n• Never Miss a Warranty Period\n• Convenience at Your Doorstep\n• Peace of Mind\n• Using PAY-PER-CLAIM, access Wonds to request warranty service or replacement anytime, anywhere`,
    date: "January 2025",
    category: "Product",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&auto=format&fit=crop&q=60",
    author: "Cyboglabs Team"
  }
];

export const termsAndConditions = {
  lastUpdated: "July 2025",
  sections: [
    {
      title: "1. Acceptance of Terms",
      content: "By accessing and using the CYBOGLABS website and services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by these terms, please do not use our services."
    },
    {
      title: "2. Description of Services",
      content: "CYBOGLABS provides research and development services, including but not limited to applied research, experimental development, reverse engineering, and technology challenge solving. Our services are designed to help businesses innovate and solve complex technological problems."
    },
    {
      title: "3. Intellectual Property Rights",
      content: "All content, including but not limited to text, graphics, logos, images, and software, is the property of CYBOGLABS and is protected by international copyright laws. You may not reproduce, distribute, or create derivative works without our express written permission."
    },
    {
      title: "4. User Responsibilities",
      content: "Users agree to use our services only for lawful purposes and in accordance with these Terms. You are responsible for maintaining the confidentiality of any account information and for all activities that occur under your account."
    },
    {
      title: "5. Limitation of Liability",
      content: "CYBOGLABS shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services. Our total liability shall not exceed the amount paid by you for the services in question."
    },
    {
      title: "6. Privacy Policy",
      content: "We are committed to protecting your privacy. Any personal information collected through our website will be handled in accordance with our Privacy Policy. We do not sell, trade, or rent your personal information to third parties."
    },
    {
      title: "7. Confidentiality",
      content: "CYBOGLABS maintains strict confidentiality regarding all client projects and proprietary information. We implement industry-standard security measures to protect your data and intellectual property."
    },
    {
      title: "8. Service Modifications",
      content: "CYBOGLABS reserves the right to modify, suspend, or discontinue any part of our services at any time without prior notice. We will make reasonable efforts to notify users of significant changes."
    },
    {
      title: "9. Governing Law",
      content: "These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in India."
    },
    {
      title: "10. Contact Information",
      content: "For questions or concerns regarding these Terms and Conditions, please contact us at support@cyboglabs.com. We aim to respond to all inquiries within 48 business hours."
    }
  ]
};

export const privacyPolicy = {
  lastUpdated: "July 2025",
  sections: [
    {
      title: "1. Information We Collect",
      content: "We collect information you provide directly to us, such as your name, email address, phone number, and any other information you choose to provide when contacting us or using our services."
    },
    {
      title: "2. How We Use Your Information",
      content: "We use the information we collect to provide, maintain, and improve our services, communicate with you about our products and services, and protect our rights and the rights of our users."
    },
    {
      title: "3. Information Sharing",
      content: "We do not share your personal information with third parties except as described in this policy or with your consent. We may share information with service providers who assist us in operating our business."
    },
    {
      title: "4. Data Security",
      content: "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction."
    },
    {
      title: "5. Your Rights",
      content: "You have the right to access, correct, or delete your personal information. You may also have the right to restrict or object to certain processing of your information."
    },
    {
      title: "6. Cookies and Tracking",
      content: "We use cookies and similar tracking technologies to collect information about your browsing activities. You can control cookies through your browser settings."
    },
    {
      title: "7. Changes to This Policy",
      content: "We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the 'Last Updated' date."
    },
    {
      title: "8. Contact Us",
      content: "If you have any questions about this Privacy Policy, please contact us at support@cyboglabs.com."
    }
  ]
};

export const careers = [
  {
    id: 1,
    title: "DevOps Engineer",
    department: "Infrastructure & Operations",
    location: "Hybrid / Remote",
    type: "Full-time",
    experience: "3-6 years",
    salary: "Competitive",
    posted: "July 2025",
    shortDescription: "Join our infrastructure team to build and maintain scalable, reliable, and secure CI/CD pipelines and cloud infrastructure.",
    description: `We are seeking an experienced DevOps Engineer to join our Infrastructure & Operations team. You will be responsible for designing, implementing, and maintaining our continuous integration and continuous deployment (CI/CD) pipelines, cloud infrastructure, and automation frameworks.

As a DevOps Engineer at CYBOGLABS, you will work closely with our development, QA, and security teams to ensure seamless software delivery while maintaining high availability and performance standards across all our products.`,
    responsibilities: [
      "Design, implement, and maintain CI/CD pipelines using Jenkins, GitLab CI, GitHub Actions, or similar tools",
      "Manage and optimize cloud infrastructure on AWS, GCP, or Azure using Infrastructure as Code (IaC) tools like Terraform, CloudFormation, or Pulumi",
      "Implement and maintain containerization strategies using Docker, Kubernetes (K8s), and Helm charts",
      "Set up and manage monitoring, logging, and alerting systems using Prometheus, Grafana, ELK Stack, or Datadog",
      "Automate infrastructure provisioning, configuration management, and deployment processes using Ansible, Chef, or Puppet",
      "Implement security best practices including secrets management, vulnerability scanning, and compliance automation",
      "Optimize system performance, scalability, and cost efficiency across cloud environments",
      "Collaborate with development teams to improve application deployment processes and reduce time-to-production",
      "Maintain documentation for infrastructure architecture, runbooks, and operational procedures",
      "Participate in on-call rotation and incident response activities"
    ],
    requirements: [
      "Bachelor's degree in Computer Science, Information Technology, or related field",
      "3-6 years of hands-on experience in DevOps, SRE, or Platform Engineering roles",
      "Strong proficiency in Linux/Unix system administration and shell scripting (Bash, Python)",
      "Experience with containerization technologies: Docker, Kubernetes, container registries",
      "Hands-on experience with at least one major cloud platform (AWS, GCP, Azure)",
      "Proficiency in Infrastructure as Code tools: Terraform, CloudFormation, or Pulumi",
      "Experience with CI/CD tools: Jenkins, GitLab CI, GitHub Actions, ArgoCD",
      "Knowledge of monitoring and observability tools: Prometheus, Grafana, ELK, Jaeger",
      "Understanding of networking concepts: TCP/IP, DNS, load balancing, CDN, VPN",
      "Familiarity with security practices: IAM, secrets management (Vault), SSL/TLS"
    ],
    niceToHave: [
      "Kubernetes certifications (CKA, CKAD, CKS)",
      "AWS/GCP/Azure professional certifications",
      "Experience with GitOps methodologies and tools (ArgoCD, Flux)",
      "Knowledge of service mesh technologies (Istio, Linkerd)",
      "Experience with chaos engineering practices",
      "Familiarity with FinOps and cloud cost optimization"
    ],
    techStack: ["AWS", "Kubernetes", "Terraform", "Docker", "Jenkins", "Prometheus", "Grafana", "Python", "Ansible", "GitLab CI"]
  },
  {
    id: 2,
    title: "AI/ML Architect",
    department: "Artificial Intelligence",
    location: "Hybrid / Remote",
    type: "Full-time",
    experience: "5-10 years",
    salary: "Competitive",
    posted: "July 2025",
    shortDescription: "Lead the design and implementation of cutting-edge AI/ML systems that power our intelligent products and platforms.",
    description: `We are looking for a visionary AI/ML Architect to lead the design and implementation of machine learning systems across our product portfolio. You will be responsible for defining the AI strategy, architecting scalable ML pipelines, and ensuring our models deliver real-world impact.

At CYBOGLABS, you will work on diverse AI applications including computer vision, natural language processing, predictive analytics, and intelligent automation systems. This role requires deep technical expertise combined with the ability to translate complex business requirements into robust AI solutions.`,
    responsibilities: [
      "Define and execute the AI/ML architecture strategy aligned with business objectives and product roadmap",
      "Design end-to-end ML pipelines including data ingestion, feature engineering, model training, validation, and deployment",
      "Architect scalable MLOps infrastructure using tools like MLflow, Kubeflow, or SageMaker",
      "Lead the development of deep learning models using PyTorch, TensorFlow, or JAX for computer vision and NLP applications",
      "Implement and optimize transformer-based architectures (BERT, GPT, Vision Transformers) for production systems",
      "Design distributed training strategies for large-scale models using techniques like data parallelism and model parallelism",
      "Establish best practices for model versioning, A/B testing, monitoring, and continuous retraining",
      "Evaluate and integrate state-of-the-art research papers and open-source models into production systems",
      "Mentor and guide ML engineers, conduct code reviews, and drive technical excellence",
      "Collaborate with product managers and stakeholders to define AI capabilities and success metrics"
    ],
    requirements: [
      "Master's or PhD in Computer Science, Machine Learning, Statistics, or related quantitative field",
      "5-10 years of experience in machine learning with at least 3 years in architectural/lead roles",
      "Deep expertise in deep learning frameworks: PyTorch, TensorFlow, JAX",
      "Strong foundation in ML algorithms: supervised/unsupervised learning, reinforcement learning, optimization",
      "Experience with NLP technologies: transformers, LLMs, embeddings, RAG architectures",
      "Proficiency in computer vision: CNNs, object detection (YOLO, Faster R-CNN), image segmentation",
      "Hands-on experience with MLOps platforms: MLflow, Kubeflow, SageMaker, Vertex AI",
      "Strong programming skills in Python with expertise in NumPy, Pandas, Scikit-learn",
      "Experience with distributed computing frameworks: Spark, Dask, Ray",
      "Knowledge of cloud ML services: AWS SageMaker, GCP Vertex AI, Azure ML"
    ],
    niceToHave: [
      "Published research papers in top-tier ML conferences (NeurIPS, ICML, CVPR, ACL)",
      "Experience with generative AI: GANs, diffusion models, large language models",
      "Knowledge of edge ML deployment: TensorRT, ONNX, TensorFlow Lite",
      "Experience with graph neural networks and knowledge graphs",
      "Familiarity with federated learning and privacy-preserving ML",
      "Contributions to open-source ML projects"
    ],
    techStack: ["PyTorch", "TensorFlow", "Python", "Kubeflow", "MLflow", "Transformers", "CUDA", "AWS SageMaker", "Docker", "Kubernetes"]
  },
  {
    id: 3,
    title: "Cloud Architect",
    department: "Cloud Infrastructure",
    location: "Hybrid / Remote",
    type: "Full-time",
    experience: "6-10 years",
    salary: "Competitive",
    posted: "July 2025",
    shortDescription: "Design and implement enterprise-grade cloud architectures that are secure, scalable, and cost-optimized.",
    description: `We are seeking a seasoned Cloud Architect to design and implement enterprise-grade cloud solutions that power our products and services. You will be responsible for defining cloud strategy, designing multi-cloud architectures, and ensuring our infrastructure meets the highest standards of security, reliability, and performance.

As a Cloud Architect at CYBOGLABS, you will work across multiple cloud platforms to build resilient, scalable systems that support our R&D initiatives and production workloads. This role requires deep expertise in cloud technologies combined with strong leadership and communication skills.`,
    responsibilities: [
      "Define and execute cloud architecture strategy across AWS, GCP, and Azure environments",
      "Design highly available, fault-tolerant, and scalable cloud architectures using well-architected framework principles",
      "Architect microservices-based applications using containers, Kubernetes, and serverless technologies",
      "Implement cloud security architectures including identity management, network security, and data protection",
      "Design data architectures leveraging cloud-native databases, data lakes, and analytics services",
      "Develop disaster recovery and business continuity strategies with defined RPO/RTO objectives",
      "Optimize cloud costs through reserved instances, spot instances, and architectural improvements",
      "Create technical documentation, architecture diagrams, and design patterns for cloud solutions",
      "Lead cloud migration initiatives including assessment, planning, and execution",
      "Mentor engineering teams on cloud best practices and emerging technologies"
    ],
    requirements: [
      "Bachelor's or Master's degree in Computer Science, Engineering, or related field",
      "6-10 years of experience in cloud architecture and engineering roles",
      "Expert-level knowledge of at least one major cloud platform (AWS, GCP, or Azure)",
      "Strong experience with cloud-native architectures: microservices, containers, Kubernetes, serverless",
      "Deep understanding of networking: VPC, subnets, load balancing, CDN, DNS, VPN, Direct Connect",
      "Experience with Infrastructure as Code: Terraform, CloudFormation, Pulumi, ARM templates",
      "Knowledge of cloud security: IAM, KMS, security groups, WAF, Shield, compliance frameworks",
      "Experience with database technologies: RDS, DynamoDB, Cloud SQL, Cosmos DB, Redis, Elasticsearch",
      "Understanding of event-driven architectures: Kafka, SQS, SNS, Pub/Sub, EventBridge",
      "Strong communication skills with ability to present to executive stakeholders"
    ],
    niceToHave: [
      "AWS Solutions Architect Professional or equivalent certifications",
      "Multi-cloud architecture experience across AWS, GCP, and Azure",
      "Experience with hybrid cloud and edge computing solutions",
      "Knowledge of FinOps practices and cloud cost management tools",
      "Experience with compliance frameworks: SOC2, HIPAA, GDPR, ISO 27001",
      "Familiarity with cloud-native observability: distributed tracing, APM"
    ],
    techStack: ["AWS", "GCP", "Azure", "Kubernetes", "Terraform", "Docker", "Kafka", "PostgreSQL", "Redis", "CloudFormation"]
  },
  {
    id: 4,
    title: "Hardware & Embedded Systems Engineer",
    department: "Hardware Engineering",
    location: "On-site / Hybrid",
    type: "Full-time",
    experience: "4-8 years",
    salary: "Competitive",
    posted: "July 2025",
    shortDescription: "Design and develop innovative hardware solutions and embedded systems for our cutting-edge IoT and automation products.",
    description: `We are looking for a talented Hardware & Embedded Systems Engineer to join our Hardware Engineering team. You will be responsible for designing, developing, and testing embedded systems and hardware solutions that power our IoT devices, automation platforms, and intelligent products.

At CYBOGLABS, you will work on the complete hardware development lifecycle from concept and schematic design to PCB layout, prototyping, and production. This role offers the opportunity to work on diverse projects including sensor systems, communication modules, and edge computing devices.`,
    responsibilities: [
      "Design embedded systems architecture including microcontroller/microprocessor selection and system integration",
      "Develop firmware for ARM Cortex-M, ESP32, STM32, and other embedded platforms using C/C++",
      "Create schematic designs and PCB layouts using Altium Designer, KiCad, or Eagle",
      "Implement communication protocols: UART, SPI, I2C, CAN, Ethernet, Wi-Fi, BLE, LoRa, Zigbee",
      "Design power management systems including battery management, voltage regulation, and low-power optimization",
      "Develop real-time operating system (RTOS) based applications using FreeRTOS, Zephyr, or ThreadX",
      "Integrate sensors, actuators, and peripheral devices with embedded systems",
      "Perform hardware debugging using oscilloscopes, logic analyzers, spectrum analyzers, and JTAG debuggers",
      "Design for manufacturability (DFM) and design for testability (DFT) considerations",
      "Create technical documentation including specifications, schematics, and test procedures"
    ],
    requirements: [
      "Bachelor's or Master's degree in Electrical Engineering, Electronics, or Computer Engineering",
      "4-8 years of experience in embedded systems and hardware design",
      "Strong proficiency in embedded C/C++ programming for resource-constrained systems",
      "Experience with ARM Cortex-M microcontrollers (STM32, NXP, Nordic) and development tools",
      "Hands-on experience with PCB design: schematic capture, layout, signal integrity, EMC considerations",
      "Knowledge of communication protocols: UART, SPI, I2C, CAN bus, Modbus, MQTT",
      "Experience with RTOS concepts: tasks, semaphores, queues, memory management",
      "Proficiency with lab equipment: oscilloscopes, logic analyzers, multimeters, power supplies",
      "Understanding of analog and digital circuit design principles",
      "Experience with version control (Git) and embedded development workflows"
    ],
    niceToHave: [
      "Experience with RF design and wireless protocols (BLE, Wi-Fi, LoRa, cellular)",
      "Knowledge of FPGA development using Verilog or VHDL",
      "Experience with Linux-based embedded systems (Yocto, Buildroot)",
      "Familiarity with motor control and power electronics",
      "Understanding of functional safety standards (IEC 61508, ISO 26262)",
      "Experience with EMC testing and certification processes"
    ],
    techStack: ["C", "C++", "ARM Cortex-M", "STM32", "ESP32", "FreeRTOS", "Altium Designer", "Python", "I2C", "SPI", "BLE", "Wi-Fi"]
  }
];

export const internships = [
  {
    id: 1,
    title: "AI/ML Research Intern",
    department: "Artificial Intelligence",
    duration: "3-6 months",
    location: "Hybrid",
    stipend: "Paid",
    posted: "July 2025",
    description: "Work alongside our AI team to research and implement cutting-edge machine learning algorithms. You will get hands-on experience with deep learning frameworks, computer vision, and natural language processing projects.",
    requirements: [
      "Currently pursuing B.Tech/M.Tech/PhD in Computer Science, AI/ML, or related field",
      "Strong foundation in mathematics: linear algebra, calculus, probability, and statistics",
      "Programming proficiency in Python with knowledge of NumPy, Pandas",
      "Familiarity with deep learning frameworks: PyTorch or TensorFlow",
      "Understanding of ML concepts: regression, classification, neural networks",
      "Good communication skills and ability to work in a team"
    ],
    learnings: [
      "Real-world ML model development and deployment",
      "MLOps practices and tools",
      "Research methodology and paper implementation",
      "Industry best practices in AI development"
    ]
  },
  {
    id: 2,
    title: "Full Stack Development Intern",
    department: "Software Engineering",
    duration: "3-6 months",
    location: "Hybrid",
    stipend: "Paid",
    posted: "July 2025",
    description: "Join our product development team to build scalable web applications. You will work on both frontend and backend technologies, contributing to real products that impact thousands of users.",
    requirements: [
      "Currently pursuing B.Tech/M.Tech in Computer Science or related field",
      "Knowledge of HTML, CSS, JavaScript, and at least one frontend framework (React/Vue/Angular)",
      "Basic understanding of backend development (Node.js/Python/Java)",
      "Familiarity with databases (SQL/NoSQL)",
      "Understanding of REST APIs and web services",
      "Version control experience with Git"
    ],
    learnings: [
      "Modern web development practices",
      "Agile development methodology",
      "Cloud deployment and DevOps basics",
      "Code review and collaboration workflows",
      "End-to-end full stack application architecture and integration"

    ]
  },
  {
    id: 3,
    title: "Embedded Systems Intern",
    department: "Hardware Engineering",
    duration: "4-6 months",
    location: "On-site",
    stipend: "Paid",
    posted: "July 2025",
    description: "Get hands-on experience with embedded systems development, working on IoT devices, sensor integration, and firmware development. Perfect for students passionate about hardware-software integration.",
    requirements: [
      "Currently pursuing B.Tech/M.Tech in Electronics, Electrical, or Computer Engineering",
      "Basic knowledge of C/C++ programming",
      "Understanding of microcontrollers (Arduino, ESP32, STM32)",
      "Familiarity with basic electronics and circuit design",
      "Knowledge of communication protocols (UART, SPI, I2C) is a plus",
      "Enthusiasm for hardware projects and IoT"
    ],
    learnings: [
      "Professional firmware development practices",
      "PCB design and prototyping",
      "Real-time operating systems (RTOS)",
      "Hardware debugging techniques"
    ]
  },
  {
    id: 4,
    title: "Cloud & DevOps Intern",
    department: "Infrastructure",
    duration: "3-6 months",
    location: "Remote",
    stipend: "Paid",
    posted: "July 2025",
    description: "Learn cloud infrastructure and DevOps practices by working on real deployment pipelines, containerization, and cloud services. Ideal for students interested in modern infrastructure technologies.",
    requirements: [
      "Currently pursuing B.Tech/M.Tech in Computer Science or IT",
      "Basic knowledge of Linux and command line",
      "Understanding of networking fundamentals",
      "Familiarity with at least one programming language (Python/Bash)",
      "Interest in cloud technologies (AWS/GCP/Azure)",
      "Basic understanding of Docker is a plus"
    ],
    learnings: [
      "CI/CD pipeline development",
      "Container orchestration with Kubernetes",
      "Infrastructure as Code (Terraform)",
      "Cloud services and architecture patterns"
    ]
  }
];

export const eventsAndNews = [
  {
    id: 1,
    type: "event",
    title: "Matrivis Selected for IIT Madras Port Innovation Challenge",
    subtitle: "Chennai Port Operations Transformation",
    date: "August 2025",
    location: "IIT Madras, Chennai",
    category: "Achievement",
    featured: true,
    image: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=800&auto=format&fit=crop&q=60",
    shortDescription: "Our Matrivis digital warehouse intelligence system has been selected by IIT Madras for the prestigious Port Innovation Challenge to transform Chennai port operations.",
    fullContent: `We are thrilled to announce that CYBOGLABS' Matrivis platform has been selected by the Indian Institute of Technology Madras (IIT-M) for the prestigious Port Innovation Challenge 2025, focusing on transforming Chennai port operations.

**About the Selection**

Matrivis was chosen from over 150 submissions across India for its innovative approach to digital warehouse intelligence and port logistics optimization. The selection committee, comprising industry experts and IIT-M faculty, recognized Matrivis for its:

• Real-time cargo tracking and visibility solutions
• AI-powered predictive analytics for port operations
• Seamless integration with existing port management systems
• Scalable architecture designed for high-volume operations

**Project Scope**

The pilot project will be implemented at Chennai Port Trust, one of India's largest ports handling over 50 million tonnes of cargo annually. Key focus areas include:

• Container tracking and yard management optimization
• Automated berth allocation and vessel scheduling
• Predictive maintenance for port equipment
• Digital twin implementation for operational simulation

**Timeline & Next Steps**

The project will commence in August 2025 with a 12-month implementation roadmap. Our team will work closely with IIT-M researchers and Chennai Port Authority to deliver a transformative solution.

This recognition validates our commitment to building technology that solves real-world infrastructure challenges.`
  },
  {
    id: 2,
    type: "news",
    title: "The Rise of Edge AI: Transforming Industrial IoT",
    subtitle: "How Edge Computing is Revolutionizing Manufacturing",
    date: "July 2025",
    category: "Technology",
    featured: false,
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&auto=format&fit=crop&q=60",
    shortDescription: "Edge AI is revolutionizing industrial IoT by bringing machine learning capabilities directly to factory floors, enabling real-time decision making without cloud dependency.",
    fullContent: `Edge AI represents a paradigm shift in how we deploy artificial intelligence in industrial environments. By processing data locally on edge devices, manufacturers can achieve unprecedented levels of automation and efficiency.

**What is Edge AI?**

Edge AI refers to the deployment of artificial intelligence algorithms directly on edge devices—sensors, cameras, and embedded systems—rather than relying on cloud-based processing. This approach offers several critical advantages:

• **Ultra-low Latency**: Real-time processing enables immediate response to anomalies
• **Data Privacy**: Sensitive operational data stays on-premises
• **Bandwidth Efficiency**: Only processed insights are transmitted
• **Reliability**: Operations continue even without internet connectivity

**Industrial Applications**

Edge AI is transforming various industrial sectors:

**Predictive Maintenance**
Machine learning models running on edge devices analyze vibration patterns, temperature fluctuations, and acoustic signatures to predict equipment failures before they occur, reducing downtime by up to 50%.

**Quality Control**
Computer vision systems powered by edge AI inspect products at production line speeds, detecting defects invisible to human inspectors with 99.9% accuracy.

**Safety Monitoring**
Real-time video analytics identify safety hazards, unauthorized access, and compliance violations, creating safer work environments.

**The Technology Stack**

Modern edge AI deployments typically utilize:
• NVIDIA Jetson or Google Coral for inference acceleration
• TensorRT or TensorFlow Lite for model optimization
• Docker containers for deployment flexibility
• MQTT or OPC-UA for industrial communication

**Future Outlook**

As edge hardware becomes more powerful and AI models more efficient, we expect edge AI to become the default deployment model for industrial applications by 2027.`
  },
  {
    id: 3,
    type: "event",
    title: "CYBOGLABS at India Tech Summit 2025",
    subtitle: "Showcasing Innovation in R&D",
    date: "September 2025",
    location: "Bangalore International Exhibition Centre",
    category: "Conference",
    featured: false,
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&auto=format&fit=crop&q=60",
    shortDescription: "Join us at India Tech Summit 2025 where we will be showcasing our latest innovations in AI, IoT, and embedded systems.",
    fullContent: `CYBOGLABS is excited to participate in India Tech Summit 2025, one of the largest technology conferences in South Asia, bringing together over 10,000 tech enthusiasts, entrepreneurs, and industry leaders.

**Our Presence**

Visit us at **Booth #A-127** in the Innovation Pavilion where we will be demonstrating:

• **Pixzee.ai Live Demo**: Experience our AI-powered apparel analysis platform in action
• **Seabot.ai Showcase**: Interactive demonstration of marine data monitoring capabilities  
• **Hardware Prototypes**: Hands-on experience with our embedded systems projects

**Speaking Sessions**

Our team will be presenting at multiple sessions:

**Day 1 - 10:30 AM**
"Building AI Products for Real-World Impact"
Speaker: AI/ML Architecture Team

**Day 2 - 2:00 PM**
"Hardware-Software Co-Development: Lessons from the Field"
Speaker: Hardware Engineering Team

**Networking Opportunities**

We are actively seeking:
• Partnership opportunities with technology companies
• Collaboration with academic institutions
• Talented engineers to join our team

**Registration**

Conference attendees can pre-book a demo slot at our booth. Limited slots available for exclusive product previews.

See you in Bangalore!`
  },
  {
    id: 4,
    type: "news",
    title: "Quantum Computing: The Next Frontier for R&D",
    subtitle: "Understanding Quantum Advantage in Problem Solving",
    date: "July 2025",
    category: "Research",
    featured: false,
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&auto=format&fit=crop&q=60",
    shortDescription: "Quantum computing is transitioning from theoretical research to practical applications, promising to revolutionize drug discovery, optimization, and cryptography.",
    fullContent: `Quantum computing has moved beyond the realm of theoretical physics into practical engineering, with major implications for research and development across industries.

**Quantum Basics**

Unlike classical computers that use bits (0 or 1), quantum computers use qubits that can exist in superposition—simultaneously representing both 0 and 1. This property, combined with quantum entanglement, enables exponential computational speedup for certain problem classes.

**Current State of Technology**

• **IBM**: 1,121-qubit Condor processor
• **Google**: Demonstrated quantum supremacy with 72-qubit Bristlecone
• **IonQ**: Trapped ion systems with high gate fidelity
• **D-Wave**: 5,000+ qubit quantum annealing systems

**Practical Applications**

**Drug Discovery**
Quantum simulation of molecular interactions could reduce drug development timelines from 10+ years to months, potentially saving billions in R&D costs.

**Optimization Problems**
Supply chain optimization, portfolio management, and logistics routing can be solved exponentially faster using quantum algorithms like QAOA and VQE.

**Cryptography**
While quantum computers threaten current encryption (RSA, ECC), they also enable quantum key distribution (QKD) for theoretically unbreakable communication.

**Machine Learning**
Quantum machine learning algorithms promise speedups in training large models and processing high-dimensional data.

**Challenges Ahead**

• Maintaining qubit coherence at scale
• Error correction overhead
• Cryogenic cooling requirements
• Algorithm development for near-term devices

**Timeline to Practical Advantage**

Industry experts predict commercially viable quantum advantage for specific applications by 2028-2030, with broader adoption following as hardware matures.`
  },
  {
    id: 5,
    type: "news",
    title: "5G and IoT: Enabling the Connected Factory",
    subtitle: "Private 5G Networks Transform Manufacturing",
    date: "June 2025",
    category: "Technology",
    featured: false,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&auto=format&fit=crop&q=60",
    shortDescription: "Private 5G networks are revolutionizing industrial IoT deployments, offering unprecedented reliability, bandwidth, and low latency for connected factory applications.",
    fullContent: `The convergence of 5G technology and Industrial IoT is creating new possibilities for smart manufacturing, with private 5G networks emerging as the connectivity backbone for Industry 4.0.

**Why Private 5G?**

Traditional WiFi and wired networks struggle to meet the demands of modern manufacturing:

• **Reliability**: 99.999% uptime requirement for critical operations
• **Latency**: Sub-millisecond response for real-time control
• **Density**: Thousands of devices per square kilometer
• **Security**: Isolated network with complete data control

Private 5G addresses all these challenges while providing the flexibility of wireless connectivity.

**Key Use Cases**

**Autonomous Mobile Robots (AMRs)**
5G enables real-time coordination of robot fleets with precise positioning and instant response to dynamic environments.

**Augmented Reality Maintenance**
Technicians using AR headsets receive real-time guidance overlaid on equipment, with high-bandwidth video streaming and low-latency interaction.

**Digital Twin Synchronization**
Real-time sensor data feeds into digital twins, enabling predictive simulation and optimization of production processes.

**Remote Expert Assistance**
High-definition video conferencing with haptic feedback allows remote experts to guide on-site technicians through complex procedures.

**Implementation Considerations**

• Spectrum licensing (CBRS in US, local regulations elsewhere)
• Integration with existing OT systems
• Device ecosystem and compatibility
• Total cost of ownership vs. WiFi 6

**Market Outlook**

The private 5G market for manufacturing is projected to grow from $1.2B in 2024 to $8.5B by 2028, driven by increasing automation demands and decreasing equipment costs.`
  },
  {
    id: 6,
    type: "event",
    title: "Workshop: Introduction to Embedded AI",
    subtitle: "Hands-on Learning with TinyML",
    date: "October 2025",
    location: "CYBOGLABS Office / Virtual",
    category: "Workshop",
    featured: false,
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&auto=format&fit=crop&q=60",
    shortDescription: "A hands-on workshop teaching the fundamentals of deploying machine learning models on microcontrollers using TinyML frameworks.",
    fullContent: `CYBOGLABS is hosting an intensive workshop on Embedded AI and TinyML, designed for engineers and students looking to deploy machine learning on resource-constrained devices.

**Workshop Overview**

This 2-day workshop covers the complete pipeline from model development to deployment on microcontrollers. Participants will build working prototypes using real hardware.

**What You Will Learn**

**Day 1: Foundations**
• Introduction to TinyML and edge inference
• Model architectures suitable for microcontrollers
• Quantization and optimization techniques
• TensorFlow Lite Micro framework deep-dive

**Day 2: Hands-on Implementation**
• Setting up development environment
• Building a keyword spotting model
• Deploying on Arduino Nano 33 BLE Sense
• Performance profiling and optimization

**Prerequisites**

• Basic Python programming knowledge
• Familiarity with machine learning concepts
• No hardware experience required (kit provided)

**What's Included**

• Arduino Nano 33 BLE Sense development kit (yours to keep)
• Workshop materials and code repositories
• Certificate of completion
• Access to CYBOGLABS learning community

**Registration Details**

• **Date**: October 15-16, 2025
• **Mode**: Hybrid (In-person + Virtual)
• **Capacity**: 30 participants (in-person), unlimited (virtual)
• **Fee**: ₹2,500 (students), ₹5,000 (professionals)

Early bird discount of 20% available until September 30, 2025.`
  }
];
